import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Calendar, ShoppingCart } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BenefitsRowSection() {
  const benefits = [{
    icon: Zap,
    title: 'Ricette in 15 minuti',
    desc: 'Opzioni veloci e pratiche per il giorno per giorno.'
  }, {
    icon: ShoppingCart,
    title: 'Ingredienti accessibili',
    desc: 'Cose che trovi in qualsiasi supermercato.'
  }, {
    icon: Calendar,
    title: 'Menù settimanali',
    desc: 'Così non devi pensare cosa cucinare ogni mattina.'
  }];
  return <section className="bg-white py-12 px-4 border-t border-gray-200" data-id="element-14">
      <div className="max-w-5xl mx-auto text-center" data-id="element-15">
        <h3 className="text-2xl font-bold text-[#1f2e10] mb-10" data-id="element-16">
          Puoi usarlo <span className="text-green-600" data-id="element-17">OGGI</span>, anche se sei
          esausta:
        </h3>

        <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-18">
          {benefits.map((benefit, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-gray-50 p-6 rounded-2xl border border-gray-100 flex flex-col items-center text-center" data-id="element-19">
              <div className="bg-[#e8f5e9] p-4 rounded-full mb-4 text-green-600" data-id="element-20">
                <benefit.icon size={32} data-id="element-21" />
              </div>
              <h4 className="font-bold text-lg text-[#1f2e10] mb-2" data-id="element-22">
                {benefit.title}
              </h4>
              <p className="text-gray-600" data-id="element-23">{benefit.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-24">
          <CTAButton href="#pricing" data-id="element-25">
            VOGLIO ACCEDERE A MERENDE FELICI™
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}